const translations = {
    primaryBoundary: 'Primary Boundary',
    primaryBoundaryPlaceholder: 'Select a primary boundary'
};

export default translations;
